import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Menu from '../components/menu';
import Footer from '../components/footer';
import ImageCarouselModal from './components/imageCarouselModal'; // Wykorzystujemy ten sam modal co w adminie

export default function Offert() {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [showCarousel, setShowCarousel] = useState(false);

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const response = await axios.get('https://megamont.pl/api/offers');
                setOffers(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Błąd podczas pobierania ofert:", error);
                setLoading(false);
            }
        };
        fetchOffers();
    }, []);

    // Funkcja pomocnicza do pobierania pierwszego zdjęcia z JSONa
    const getFirstImage = (offer) => {
        if (!offer.images) return null;
        try {
            const images = JSON.parse(offer.images);
            if (images.length === 0) return null;
            
            const firstImg = images[0];
            // Logika ścieżki identyczna jak w panelu admina
            return firstImg.includes('/') 
                ? `https://megamont.pl/uploads/${firstImg}` 
                : `https://megamont.pl/uploads/oferta_${offer.id}/${firstImg}`;
        } catch (e) {
            return null;
        }
    };

    return (
        <main className="MainPage">
            <Menu active={2} />
            <section className="Offert Ofpage">
                <div className="content">
                    <h1>Nasza Oferta</h1>
                    <p className="shortText">
                        Oferujemy kompleksowe usługi w zakresie konstrukcji stalowych - od
                        projektu po oddanie do użytku. Nasze doświadczenie pozwala nam
                        realizować nawet najbardziej wymagające projekty.
                    </p>
                    
                    <div className="row mt-5">
                        {loading ? (
                            <div className="text-center w-100 p-5 text-white">Ładowanie ofert...</div>
                        ) : (
                            offers.map((offer) => {
                                const mainImg = getFirstImage(offer);
                                return (
                                    <div 
                                        className="col-xl-4 col-md-6 mb-4" 
                                        key={offer.id}
                                        onClick={() => { setSelectedOffer(offer); setShowCarousel(true); }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="offerCard shadow-sm">
                                            <div className="imageWrapper">
                                                {mainImg ? (
                                                    <img src={mainImg} alt={offer.name} className="offerImg" />
                                                ) : (
                                                    <div className="noImg"><i className="fas fa-building"></i></div>
                                                )}
                                                <div className="overlay">
                                                    <span>Zobacz zdjęcia</span>
                                                </div>
                                            </div>
                                            <div className="offerTitle p-3 bg-white text-center">
                                                <span className="text-uppercase fw-bold">{offer.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </section>

            {/* Modal z karuzelą zdjęć */}
            {showCarousel && selectedOffer && (
                <ImageCarouselModal 
                    Offer={selectedOffer} 
                    onClose={() => { setShowCarousel(false); setSelectedOffer(null); }} 
                />
            )}

            <Footer />

            <style>{`
                .offerCard {
                    border-radius: 15px;
                    overflow: hidden;
                    transition: transform 0.3s ease;
                    background: #fff;
                }
                .offerCard:hover {
                    transform: translateY(-10px);
                }
                .imageWrapper {
                    position: relative;
                    height: 250px;
                    width: 100%;
                    background: #222;
                    overflow: hidden;
                }
                .offerImg {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.5s ease;
                }
                .offerCard:hover .offerImg {
                    transform: scale(1.1);
                }
                .noImg {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 3rem;
                    color: #444;
                }
                .overlay {
                    position: absolute;
                    top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(13, 110, 253, 0.6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0;
                    transition: 0.3s;
                    color: white;
                    font-weight: bold;
                    text-transform: uppercase;
                }
                .offerCard:hover .overlay {
                    opacity: 1;
                }
                .offerTitle {
                    border-top: 3px solid #0d6efd;
                    color: #333;
                }
                .Ofpage .content h1 { color: white; text-align: center; }
                .Ofpage .shortText { color: #ccc; text-align: center; max-width: 800px; margin: 0 auto; }
            `}</style>
        </main>
    );
}